/**
 * localStorage / sessionStorage 的 key 常量合集（打平，无 LS/SS 分层）。
 * 禁止在业务中直接写字符串，统一从这里引用。
 *
 * 使用方式：
 *   import storageKeys from './core/storageKeys';
 *   import storage from './core/storage';
 *   storage.getLocal(storageKeys.CARTX_CUSTOMER);
 *   storage.getLocalJSON(storageKeys.CARTX_CUSTOMER);
 *   storage.setSession(storageKeys.CARTTRACK_ADD_CARD, 'true');
 */

export default {
  // ---------- sessionStorage ----------
  /** 是否已处理加购埋点，'false' 表示待上报 */
  CARTTRACK_ADD_CARD: 'carttrackAddCard',
  /** 当前加购的 variant id */
  CARTTRACK_VARIANT_ID: 'carttrackVariantId',
  /** 线下场景标记（带时间戳） */
  CARTSEE_OFFLINE: '_cartsee_offline',

  // ---------- localStorage ----------
  /** 抓取的邮箱（埋点/订阅用） */
  CARTX_EMAIL: 'cartx_email',
  /** 客户信息（订阅工具等写入） */
  CARTX_CUSTOMER: 'cartx-customer',
  /** 用户唯一标识（部分平台用 cartx_uid） */
  CARTX_UID: 'cartx_uid',
  /** 用户唯一标识（部分平台用 _cartsee_uid） */
  CARTSEE_UID: '_cartsee_uid',
  /** 用户唯一标识（woocommerce 等用 cartsee_uid，无前缀） */
  CARTSEE_UID_LEGACY: 'cartsee_uid',
  /** 加购/埋点时的购物车快照（JSON） */
  CARTX_CART: 'cartx_cart',
  /** Buy Now 场景的购物车快照（JSON） */
  CARTX_CART_BUY_NOW: 'cartx_cart_buy_now',
  /** 邮件/渠道带来的 cid 参数 */
  CARTX_CID: 'cartx_cid',
  /** 当前店铺 ID（埋点脚本 URL 的 id 参数） */
  CARTX_COMPANY_ID: 'cartx_company_id',
  /** 旧 key，部分平台仍写 cid */
  CID: 'cid',
  /** oneid（归因等） */
  CARTSEE_ONEID: '_cartsee_oneid',
  /** 调试开关：值包含 'cartsee:' 时打 log */
  DEBUG: 'debug',
  /** 部分平台用 cartx_debug 做开关 */
  CARTX_DEBUG: 'cartx_debug',
  /** 最近一次请求购物车接口的时间戳，用于节流 */
  CARTSEE_CART_TIME: '_cartsee_cart_time',
  /** 订阅/弹窗抓到的 newsletter 邮箱 */
  CARTSEE_NEWSLETTER_EMAIL: '_cartsee_newsletter_email',
  /** Checkout 页已上报过的邮箱，防重复上报 */
  CARTSEE_CHECKOUT_EMAIL: '_cartsee_checkout_email',
  /** 部分平台（如 woocommerce）用 __cx_checkout_email */
  CX_CHECKOUT_EMAIL: '__cx_checkout_email',
  /** 购物车 token（如 shopyy） */
  CARTX_CART_TOKEN: 'cartx_cart_token',
  /** web push endpoint */
  CARTX_WEB_PUSH_ENDPOINT: '_cartsee_fcm_token',
  /** 浏览类埋点前端限频缓存 */
  EVENT_REPORT_LIMIT: '_cartsee_event_report_limit',
  /** uid/oid 联系人查询结果缓存，24 小时 */
  IDENTITY_LOOKUP: '_cartsee_identity_lookup',
  /** gtag 取回的 ga（含 client_id），供后续 Site/Visit 排查注入 */
  GA_CLIENT: '_cartsee_ga_client',
  /** Identity/Capture（如 Klaviyo）上报成功缓存：含 companyId/t/email/phone，门禁灌进后续事件后视为非匿名 */
  IDENTITY_CAPTURE_OK: '_cartsee_identity_capture_ok'
};
